import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import carouselImage1 from '../assets/img/carousel.jpg';
import carouselImage2 from '../assets/img/carousel1.jpg';
import carouselImage3 from '../assets/img/carousel2.jpg';
import carouselImage4 from '../assets/img/carousel3.jpg';
import carouselImage5 from '../assets/img/carousel4.jpeg';
import congo from '../assets/img/connaitre_Congo/congo4.jpg';
import congo1 from '../assets/img/connaitre_Congo/congo6.jpg';
import congo2 from '../assets/img/connaitre_Congo/congo7.jpg';
import congo3 from '../assets/img/connaitre_Congo/congo.JPG';
import congo4 from '../assets/img/connaitre_Congo/042.JPG';
import congo5 from '../assets/img/connaitre_Congo/congo2.JPG';
import cultur from '../assets/img/Journées_culturelles/culture1.jpg';
import cultur1 from '../assets/img/Journées_culturelles/culture10.jpg';
import cultur2 from '../assets/img/Journées_culturelles/culture2.jpg';
import cultur3 from '../assets/img/Journées_culturelles/culture3.jpg';
import cultur4 from '../assets/img/Journées_culturelles/culture4.jpg';
import cultur5 from '../assets/img/Journées_culturelles/culture9.jpg';
import festival from '../assets/img/Festival/festival2.jpg';
import festival1 from '../assets/img/Festival/festival3.jpg';
import festival2 from '../assets/img/Festival/festival5.jpg';
import festival3 from '../assets/img/Festival/festival6.jpg';
import festival4 from '../assets/img/Festival/festival7.jpg';
import festival5 from '../assets/img/Festival/festival1.JPG';
import unir from '../assets/img/unir/004.JPG';
import unir1 from '../assets/img/unir/012.JPG';
import unir2 from '../assets/img/unir/036.JPG';
import unir3 from '../assets/img/unir/039.JPG';
import unir4 from '../assets/img/unir/044.JPG';
import unir5 from '../assets/img/unir/048.JPG';
import BtnFlottant from "./components/BtnFlottant";
import NavBar from './components/nav';
import Footer from './components/Footer';
import CustomCursor from './components/CustomCursor';
import img1 from '../assets/img/MAJ/1.jpg';
import img2 from '../assets/img/MAJ/2.jpg';
import img3 from '../assets/img/MAJ/3.jpg';
import img4 from '../assets/img/MAJ/4.jpg';
import img5 from '../assets/img/MAJ/5.jpg';
import img6 from '../assets/img/MAJ/6.jpg';
import img7 from '../assets/img/MAJ/7.jpg';
import img8 from '../assets/img/MAJ/8.jpg';
import img9 from '../assets/img/MAJ/9.jpg';
import img10 from '../assets/img/MAJ/10.jpg';
import img11 from '../assets/img/MAJ/11.jpg';
import img12 from '../assets/img/MAJ/12.jpg';
import img13 from '../assets/img/MAJ/13.jpg';
import img14 from '../assets/img/MAJ/14.jpg';
import img15 from '../assets/img/MAJ/15.jpg';
import img16 from '../assets/img/MAJ/16.jpg';
import img17 from '../assets/img/MAJ/17.jpg';

const Galerie = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const carouselImages = [
    carouselImage2,
    carouselImage1,
    carouselImage4,
    carouselImage3,
    carouselImage5,
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === carouselImages.length - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(interval);
  }, [currentSlide]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="overflow-x-hidden bg-gradient-to-b from-blue-600 to-indigo-800">
      <CustomCursor />
      <NavBar />

      <motion.header
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="relative h-[600px]"
      >
        <div className="relative w-full h-full overflow-hidden">
          {carouselImages.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 w-full h-full transition-opacity duration-700 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <img
                src={image}
                alt={`Slide ${index + 1}`}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/30 flex justify-center items-center">
                <div className="text-center text-white max-w-4xl px-6">
                  <motion.h1
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.3, duration: 0.8 }}
                    className="text-3xl md:text-5xl font-bold leading-tight"
                  >
                    NOS DIFFERENTS <span className="text-orange-400 block mt-2">MOMENTS EN IMAGES</span>
                  </motion.h1>
                  <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6, duration: 0.8 }}
                    className="mt-6 text-xl md:text-2xl font-light"
                  >
                    Découvrez en images nos actions, événements et initiatives pour promouvoir le Congo Brazzaville.
                  </motion.p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </motion.header>

      <BtnFlottant />

      <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="container mx-auto py-20 px-6"
      >
        <h2 className="text-5xl font-bold text-white text-center mb-4">GALERIE</h2>
        <p className="text-xl text-white/90 text-center mb-16">Découvrez en images nos moments forts et inspirants.</p>

        {[
          { title: "Faire connaitre le Congo", images: [congo, congo1, congo2, congo3, congo4, congo5] },
          { title: "Journées culturelles du Congo 2009-2011", images: [cultur, cultur1, cultur2, cultur3, cultur4, cultur5] },
          { title: "Festival de rendez-vous de l'Erdre", images: [festival, festival1, festival2, festival3, festival4, festival5] },
          { title: "Festival des Rendez-vous de l'Erdre à Nantes", images: [img1, img17, img15, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img3, img16, img2] },
          { title: "S'unir autour de projets fédérateurs", images: [unir, unir1, unir2, unir3, unir4, unir5] }
        ].map((block, blockIndex) => (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: blockIndex * 0.2 }}
            key={blockIndex}
            className="mt-16 first:mt-0"
          >
            <h3 className="text-3xl font-bold text-orange-400 mb-8">{block.title}</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
              {block.images.map((image, index) => (
                <motion.div
                  whileHover={{ y: -10 }}
                  key={index}
                  className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl group"
                >
                  <div className="relative h-72 overflow-hidden">
                    <img
                      src={image}
                      alt={`${block.title} - Image ${index + 1}`}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        ))}
      </motion.section>

      <Footer />
    </div>
  );
};

export default Galerie;